export default "__VITE_ASSET__DgqHELIc__"